import '../css/style.css'

export default function Content() {
    return(
        <div className='content'>
            <div className='header'>
                <p>To jedna z naszych specjalności, na której nieustannie koncentrujemy naszą uwagę.</p>
                <p>Specjalizujemy się szczególnie w turbo kompresorach typu CENTAC® firmy Ingersoll Rand dla których dostarczamy kompleksową ofertę usługową oraz handlową.</p>
                <p>W jej skład zalicza się pełen zakres części zamiennych oraz usług serwisowych.</p>
            </div>
            <div className='photos'>
                <a href='https://dwb.com.pl/wp-content/uploads/2023/01/DSC06028-scaled.jpg' target="_blank" rel="noreferrer"><img src="https://dwb.com.pl/wp-content/uploads/2023/01/DSC06028-scaled.jpg" alt="photo1"/></a>
                <a href='https://dwb.com.pl/wp-content/uploads/2023/01/DSC06039-scaled.jpg' target="_blank" rel="noreferrer"><img src="https://dwb.com.pl/wp-content/uploads/2023/01/DSC06039-scaled.jpg" alt="photo2"/></a>
                <a href='https://dwb.com.pl/wp-content/uploads/2023/01/DSC06068-scaled.jpg' target="_blank" rel="noreferrer"><img src="https://dwb.com.pl/wp-content/uploads/2023/01/DSC06068-scaled.jpg" alt="photo3"/></a>
            </div>
        </div>
    )
}